import React, {Component} from 'react'
import {graphql} from 'react-apollo'
import {withNamespaces, Trans} from 'react-i18next'
import {Redirect} from 'react-router-dom'
import messages from '../../../../assets/messages'
import {ACCOUNTS_QUERY, ACCOUNT_HAS_OPEN_POSITIONS_QUERY} from '../../../../graphql/queries'
import {get, isEmpty, first, flowRight as compose} from 'lodash'
import Grid from '@material-ui/core/Grid'
import StrategyAlertDialog from './StrategyAlertDialog'
import StrategyCard from './StrategyCard'
import {getStrategiesDetails, startCopying, stopCopying} from '../../../../common/utils/requests'
import StopStrategyDialog from './StopStrategyDialog'
import {config} from '../../../../config'
import Loading from '../../../Common/Loading'
import NotificationBar from '../../../Common/NotificationBar'
import {checkAccountCopyTrading} from '../../../../common/utils/accounts'
import {CHECK_PROTECTED_PASSWORD_STRATEGY_MUTATION} from '../../../../graphql/mutations'
import {BrokereeCopyTradingOffers} from '../scenes/BrokereeCopyTradingOffers'

export class CopyTrading extends Component<any,any> {

  constructor(props) {
    super(props)
    this.state = {
      status: '',
      loading: false,
      showPopup: false,
      showStopPopup: false,
      method: '',
      percentage: '',
      selectedStrategy: {},
      requestedStrategy:{},
      passwordApproved: false,
      form: {password: ''},
      errors: {},
      showPassword: false,
    }
  }

  componentDidMount() {
    const {account, history, canBeBrokereeCopyTradingFollower} = this.props
    const {common:{globalCopyTradingEnabled}} = config

    if (!checkAccountCopyTrading(account) && !canBeBrokereeCopyTradingFollower) {
      history.push(`/accounts/${account.id}`)
    } else {
      getStrategiesDetails(account.id).then((res) => {
        if (get(res,'error')) {
          this.setState({strategiesError: true})
        } else {
          if (!isEmpty(res)) {
            const providerType = get(res[0], 'copyTradingProvider')
            const enableCopyTrading = get(globalCopyTradingEnabled, providerType)
            || (!get(globalCopyTradingEnabled, providerType) && get(account.copyTrading,'isActive'))
            if (!enableCopyTrading) {
              history.push(`/accounts/${account.id}`)
            }
            this.setState({strategies: res})
          }
        }
      })
    }
  }

  requestAccess(action) {
    const {account} = this.props
    const {selectedStrategy} = this.state
    this.setState({loading:true})

    if (action === 'startCopying') {
      startCopying(account.id, selectedStrategy.accountId).then((res) => {
        if (get(res,'error')) {
          this.setState({loading:false, status: 'failure'})
        } else {
          this.setState({loading:false, status: 'success', showPopup: false})
          this.props.refetchAccounts()
        }
      })
    } else {
      stopCopying(account.id).then((res) => {
        if (get(res,'error')) {
          this.setState({loading:false, status: 'failure'})
        } else {
          this.setState({loading:false, status: 'success', showStopPopup: false})
          if (selectedStrategy.performanceFee > 0) {
            window.location.reload()
          } else {
            this.props.refetchAccounts()
          }
        }
      })
    }
  }

  requestPassword(password) {
    const {t} = this.props
    const {selectedStrategy: {accountId}} = this.state
    this.setState({loading: true})
    this.props.checkProtectedPasswordStrategy({variables: {accountId, password}}).then((res) => {
      if (!!get(res, 'data.checkProtectedPasswordStrategy'))
        this.setState({status: '', loading: false, passwordApproved: true})
      else
        this.setState({status: 'failure', loading: false, errorMessage: t(messages.passwordMismatch.i18nKey, messages.passwordMismatch.defaults)})
    }).catch(() => {
      this.setState({status: 'failure', loading: false})
    })
  }

  handleChangeForm(name, value) {
    this.setState(state => ({
      form: {...state.form, [name]: value},
      errors: {...state.errors, [name]: !value},
      status: '',
      errorMessage: '',
    }))
  }

  render() {
    const {account, hasOpenPositions, isLoading, brokereeCopyTradingOfferProps} = this.props
    const {showPopup, showStopPopup, strategies, status, errorMessage,
      strategiesError, loading, selectedStrategy, passwordApproved, form:{password}, showPassword} = this.state

    const hasActiveLegacySubscription = Boolean(account.copyTrading?.isActive)

    if ((brokereeCopyTradingOfferProps.isLoading && brokereeCopyTradingOfferProps.offers.length === 0) || isLoading) return <Loading />

    if (brokereeCopyTradingOfferProps.length === 0 && (strategies?? []).length === 0) return (
      <Redirect to={`/accounts/${account.id}`} push={false} />
    )

    return (
      <BrokereeCopyTradingOffers {...brokereeCopyTradingOfferProps} hasActiveLegacySubscription={hasActiveLegacySubscription}>
        <>
          {strategies && (strategies).map(strategy =>
            <Grid item xs={12} key={strategy.login}>
              <StrategyCard
                account={account}
                strategy={strategy}
                onClick={() => this.setState({showPopup: true, selectedStrategy: strategy, status: '', loading: false})}
                onStop={(enableStopBtn) => this.setState({showStopPopup: true, requestedStrategy: enableStopBtn, status: '', loading: false, selectedStrategy: strategy})}
                hasOpenPositions={hasOpenPositions}
                hasActiveBrokereeSubscription={Boolean(brokereeCopyTradingOfferProps.currentOfferSubscription)}
              />
            </Grid>
          )}
          {strategiesError && (
            <Grid item xs={12}>
              <NotificationBar status="error">
                <Trans {...messages.somethingWrongError} />
              </NotificationBar>
            </Grid>
          )}
          {showPopup && (
            <StrategyAlertDialog
              open={showPopup}
              status={status}
              loading={loading}
              errorMessage={errorMessage}
              strategy={selectedStrategy}
              close={() => this.setState(state => ({showPopup: false, passwordApproved: false, form: {...state.form, password: ''}}))}
              onClick={(password) => (get(selectedStrategy, 'protectedPassword') && !passwordApproved) ? this.requestPassword(password) : this.requestAccess('startCopying')}
              handleChangeForm={(name, value) => this.handleChangeForm(name, value)} passwordApproved={passwordApproved}
              onClickShow={() => this.setState(state => ({showPassword: !state.showPassword}))} password={password} showPassword={showPassword}
            />
          )}
          <StopStrategyDialog
            open={showStopPopup}
            status={status}
            loading={loading}
            close={() => this.setState({showStopPopup: false})}
            onClick={() => this.requestAccess('stopCopying')} strategy={selectedStrategy}
          />
        </>
      </BrokereeCopyTradingOffers>
    )
  }
}

export default compose(
  withNamespaces(),
  graphql(ACCOUNTS_QUERY, {
    props: ({data: {error, loading}, data, ownProps: {match}}:any) => {
      const {accountId} = match.params
      const account = get(data, 'viewer.accounts', []).find(account => account.id === Number(accountId))
      return {
        error,
        loading,
        account,
        refetchAccounts: data.refetch
      }
    }
  }),
  graphql(ACCOUNT_HAS_OPEN_POSITIONS_QUERY, {
    options: (props:any) => ({variables: {accountId: props.match.params.accountId}}),
    props: ({data: {error: errorPositions, loading: loadingPositions}, data}:any) => {
      const hasOpenPositions = get(first(get(data, 'viewer.accounts', [])), 'hasOpenPositions')
      return {
        errorPositions,
        loadingPositions,
        hasOpenPositions,
      }
    }
  }),
  graphql(CHECK_PROTECTED_PASSWORD_STRATEGY_MUTATION, {
    name: 'checkProtectedPasswordStrategy',
  }),
)(CopyTrading)
